<template>
  <div class="textfield">
    <label
      v-if="!!label"
      class="textfield__label m-description"
    >
      {{ label }}
    </label>
    <input
      class="textfield__input"
      :type="type"
      :value="value"
      :disabled="disabled"
      @input="$emit('input', $event.target.value)"
      @focus="$emit('focus', true)"
      @blur="$emit('focus', false)"
    >
  </div>
</template>

<script>
export default {
  name: 'm-input',
  props: {
    value: {
      type: [String, Number],
      default: '',
    },
    label: {
      type: String,
    },
    type: {
      type: String,
      default: 'text'
    },
    disabled: {
      type: Boolean,
      default: false
    },
  },
}
</script>

<style lang="scss" scoped>
.textfield {
  max-width: 500px;
  width: 100%;
  padding: 10px 0;

  &__label {
    display: block;
    margin-bottom: 0.25rem;
  }

  &__input {
    display: block;
    max-width: 500px;
    width: 94%;
    padding: 0.375rem 0.75rem;
    font-family: inherit;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #212529;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid $primary-old;
    border-radius: 0.25rem;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;

    &:focus {
      color: #212529;
      background-color: #fff;
      border-color: $primary-old;
      outline: 0;
      box-shadow: 0 0 0 0.2rem $light-primary-old;
    }
  }
}
</style>